import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Txt } from "../../../../components/Txt";
import styles from "./AddressInfo.module.scss";
export const AddressStreetInfoStandardVariant = ({ streetNumber = "", streetName = "", streetAdditional = "", city, postcode, countryName, isReversed, hidePostCode = false, }) => {
    const postCodeText = !hidePostCode ? postcode : "";
    const addressData = isReversed
        ? `${streetNumber} ${streetName} ${streetAdditional}`
        : `${streetName} ${streetNumber} ${streetAdditional}`;
    return (_jsxs(_Fragment, { children: [_jsx(Txt, { dataTestId: "AddressInfoStreet", children: addressData }), _jsxs(Txt, { dataTestId: "AddressInfoCity", children: [city, " ", postCodeText, " ", _jsx(Txt, { dataTestId: "AddressInfoCountry", className: styles.countryName, children: countryName })] })] }));
};
//# sourceMappingURL=AddressStreetInfoStandardVariant.js.map